import { practice } from "../../data/practice";
import { getSitePageByPath } from "../../data/site-registry";

export function buildBreadcrumbList(pathname: string) {
  const page = getSitePageByPath(pathname);
  const items = [
    {
      "@type": "ListItem",
      position: 1,
      name: "Home",
      item: practice.baseUrl,
    },
  ];

  if (pathname !== "/" && page) {
    items.push({
      "@type": "ListItem",
      position: 2,
      name: page.label,
      item: `${practice.baseUrl}${pathname}`,
    });
  }

  return {
    "@type": "BreadcrumbList",
    itemListElement: items,
  };
}
